<template>
  <div v-if="loading" class="text-center mt-5 font-2xl text-muted">
    <i class="fal fa-spinner fa-spin" /> Analysis Data Loading...
  </div>
  <div v-else class="animated fadeIn">
    <basic-heading :title="formattedName">
      <template #right-content>
        <header-button-group :button_config="button_config" />
      </template>
    </basic-heading>
    <permission-alert-gate :permissions="'edit analysis'">
      <template #gated-content>
        <analysis-form :analysis="analysis" @submit="submit" />
      </template>
    </permission-alert-gate>
  </div>
</template>

<script>
import Vue from "vue";
import VueNotifications from "vue-notifications";
import AnalysisForm from "@/components/lab/analysis/AnalysisForm";
import BasicHeading from "@/components/shared/BasicHeading";
import HeaderButtonGroup from "@/components/shared/headerbuttons/HeaderButtonGroup";
import PermissionAlertGate from "@/components/permission/PermissionAlertGate";
import { analysisNotifications } from "@/shared/notifications";
import { getModel } from "@/shared/fetch-utils";
import { LabRepositoryFactory } from "@/repositories/lab/LabRepositoryFactory";
import { notificationOptions } from "@/shared/toast-notification-options";

const AnalysisRepository = LabRepositoryFactory.get("analysis");

Vue.use(VueNotifications, notificationOptions);

export default {
  name: "analysisEdit",
  components: {
    AnalysisForm,
    BasicHeading,
    HeaderButtonGroup,
    PermissionAlertGate,
  },
  data() {
    return {
      loading: true,
      analysis_id: this.$route.params.analysis_id || null,
      analysis: null,
    };
  },
  computed: {
    button_config() {
      return {
        buttons: [
          {
            icon: "fa-list",
            linkto: "/analysis",
            title: "Analysis list",
          },
          {
            icon: "fa-eye",
            linkto: `/analysis/${this.analysis_id}`,
            title: "View analysis",
            variant: "info",
          },
        ],
      };
    },
    analyte() {
      return this.analysis && this.analysis.analyte;
    },
    formattedName() {
      return `Update ${
        this.analyte &&
        this.analyte.sample_type &&
        this.analyte.sample_type.name
      } ${this.analysis.measurement_method || this.analysis.name}`;
    },
  },
  methods: {
    async submit(form_data) {
      try {
        await AnalysisRepository.update(this.analysis_id, form_data);
        this.editSuccess();
        this.$router.push(`/analysis/${this.analysis_id}`);
      } catch ({ response }) {
        this.editFail();
      }
    },
  },
  async created() {
    this.loading = true;

    this.analysis = await getModel({
      model_type: "analysis",
      id: this.analysis_id,
      message: this.$bvToast,
    });

    this.loading = false;
  },
  notifications: analysisNotifications,
};
</script>
